import _ from "lodash";
import store from "services/redux/store";
import { setDataByGuid } from "services/redux/data/actions";
import { dataConstants } from "services/redux/data/constants";
import FetchCache from "utils/fetch/cached/FetchCache";
import FetchFavourites from "utils/fetch/FetchFavourites";
import HelperCollection from 'utils/helper-collection'
import ObjectEmployee from 'utils/objects/employee'

export default class FetchCachedFavourites
{
	static logName = 'FetchCachedFavourites';
	static values = null;
	static cacheUpdatedAt = null;
	
	static construct = () => {
		return (
			FetchCache.initialize( this, {
				identifier: 'my_favourites',
				tables: [ 'my_favourites' ],
				onExpire: this.reload,
				updated_at_max_age: ( 5 * 60 ) // updated_at needs to be refresh at most each 5 minutes for this table
			}, this.process )
		);
	};

	static fetchAll = ( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		this.construct().then( () =>
			{
			return (
				FetchCache.sniff( this.cacheUpdatedAt, {
				onFresh: () => {
					if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
						callbackSuccess( this.values )
					}
				},
				onExpired: () => {
					this.reload( {callbackSuccess, callbackError, callbackStart} )
				}
		})
			);
		});
	}

	static reload = ( { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		this.construct().then( () =>
			{
			return (
				FetchFavourites.fetchAll({
					callbackStart: callbackStart,
					callbackError: callbackError,
					callbackSuccess: ( employee_favourites ) => {

						employee_favourites = HelperCollection.filterEmpty( employee_favourites, 'guid' );

						// Save to object
						this.process( employee_favourites );

						// Save to cache!
						FetchCache.storeData( this.cacheUpdatedAt, employee_favourites, true );

						if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
							callbackSuccess( employee_favourites );
						}
					}
				})
			);
		}
		)
	}

	static process = ( employee_favourites ) => {
		this.values = ObjectEmployee.filterInvisible( employee_favourites );
		
		store.dispatch( setDataByGuid( dataConstants.FAVOURITES, this.values ) );
	}
}
